var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "m14.027 12.847 3.57 3.568-1.18 1.18-3.568-3.57a7.47 7.47 0 0 1-4.681 1.641c-4.14 0-7.5-3.36-7.5-7.5s3.36-7.5 7.5-7.5 7.5 3.36 7.5 7.5a7.47 7.47 0 0 1-1.64 4.68m-1.671-.618A5.81 5.81 0 0 0 14 8.166a5.83 5.83 0 0 0-5.833-5.833 5.83 5.83 0 0 0-5.833 5.833 5.83 5.83 0 0 0 5.833 5.833 5.81 5.81 0 0 0 4.063-1.646z"
})));
export { SvgSearchIcon as ReactComponent };
export default __webpack_public_path__ + "f9ab31de9b69a259d3584066c0e5013e.svg";